module.exports = __webpack_public_path__ + "img/portal-anoun.f4d7757e.png";